// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const STROLLER_DETAIL_ADDED_TO_PROFILE = "Ko\u010d\u00e1rek ti p\u0159ibyl <0>na profilu</0>.";
export const STROLLER_DETAIL_REMOVED_FROM_PROFILE = "Ko\u010d\u00e1rek byl odstran\u011bn\u00fd <0>z profilu</0>.";
